/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */

//Standard libraries
import React from "react";
import { Grid, Portal, Typography } from "@material-ui/core";
//custom libraries
import { ContentSection } from "../components";
import { OrderSearchForm, OrderSearchResults } from "../containers";
import { useOrderForm } from "../hooks";
import { useEffect } from "react";

import { useState } from "react";
// eslint-disable-next-line

import { useTranslation } from "react-i18next";
import AppLoader from "../components/common/AppLoader";

export default function OrderSearch() {
  const { t } = useTranslation();

  const [orders, setOrders] = useState<any>([]);
  const [totalOrders, setTotalOrders] = useState<number>(10);
  const [page, setPage] = useState<number>(1);
  const [size, setSize] = useState<number>(10);
  const [refetchOrders, setRefetchOrders] = useState(false);
  const [showLoader, setShowLoader] = React.useState(false);

  useEffect(() => {
    console.log("orders");
  }, [orders]);

  const getNext = () => {
    const totalPages = Math.ceil(totalOrders / size);
    if (page < totalPages) {
      setPage(page + 1);
    }
  };

  const getPrev = () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };

  return (
    <Grid container className="min-content-height">
      <ContentSection fullWidth={true}>
        <OrderSearchForm
          {...{
            page,
            setPage,
            size,
            setOrders,
            setTotalOrders,
            refetchOrders,
            setRefetchOrders,
            setShowLoader,
          }}
        />
        <Grid container xs={12} alignItems="center" direction="row">
          <Grid item xs={12} md={10}>
            <hr />
          </Grid>
          <Grid container xs={12} md={2} className="exportButtonGrid"></Grid>
        </Grid>
        <OrderSearchResults
          {...{
            page,
            size,
            totalOrders,
            orders,
            getPrev,
            getNext,
            setSize,
            t,
            setRefetchOrders,
            setShowLoader,
          }}
        />
      </ContentSection>
      <Portal>
        <AppLoader open={showLoader} />
      </Portal>
    </Grid>
  );
}
